import { RedirectRequest, Configuration } from '@azure/msal-browser'

export const appSettings = {
  API_URL: process.env.REACT_APP_API_URL as string,
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT as string
}

export const msalConfig: Configuration = {
  auth: {
      clientId: process.env.REACT_APP_CLIENT_ID as string,
      authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID as string}`,
      redirectUri: process.env.REACT_APP_URL as string
  },
  cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: true
  }
};

export const loginRequest: RedirectRequest = {
  scopes: [process.env.REACT_APP_SCOPE as string, "user.read"],
  redirectUri: process.env.REACT_APP_URL as string
};

export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};